export default "/assets/modules/images/Recommendation-About.svg?8256449685de051d76e4d7f893e6b9f0";